require('./../_inte/js/main')